export class Common {
 
  typeOfMealValue(meal_type=""){
    console.log(meal_type);
    var name=""; 
    if(meal_type!=''){
      var idString = meal_type; 
      
      if(idString.includes('1')){
        name+='Breakfast,';
      }

      if(idString.includes('2')){
        name+='Lunch,';
      }

      if(idString.includes('3')){ 
        name+='Dinner,';
      }

      return name.substring(0,name.length-1);
    }else{
      return;
    }
    
  }

  sharePost(type,url){ 
    if(type=='facebook'){
      window.open( 
        "https://www.facebook.com/sharer/sharer.php?u=https://propira.com/"+url, 
          "_blank", "width=600, height=450"); 
    }else if(type=='twitter'){
      window.open( 
        "https://twitter.com/intent/tweet?url=https://propira.com/"+url, 
          "_blank", "width=600, height=450"); 
    }else if(type=='linkedin'){
      window.open( 
        "https://www.linkedin.com/shareArticle?mini=true&url=https://propira.com/"+url, 
          "_blank", "width=600, height=450"); 
    }else if(type=='pinterest'){
      window.open( 
        "https://pinterest.com/pin/create/button/?url=https://propira.com/"+url, 
          "_blank", "width=600, height=450"); 
    }
    else if(type=='instagram'){
      window.open( 
        "https://www.instagram.com/?url=https://propira.com/"+url, 
          "_blank", "width=600, height=450"); 
    }
    else if(type=='google'){
      window.open( 
        'https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Propira&body=https://propira.com/'+url+'&ui=2&tf=1&pli=1?', 
          "_blank", "width=600, height=450"); 
    }else if(type=='whatsup'){
      var number = '+919694097243';
      var message = url.split(' ').join('%20');
      window.open( 
        "https://api.whatsapp.com/send?text=%20" + 'https://propira.com/'+message, 
          "_blank", "width=600, height=450"); 
    }
  }

}
